var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 120,
    viewBox: "0 0 243 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 213.502 62.5014)",
    fill: "#E3E0FB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 229.502 89.5014)",
    fill: "#E3E0FB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.502,
    cy: 61.5014,
    rx: 4.5,
    ry: 4.49859,
    transform: "rotate(-180 29.502 61.5014)",
    fill: "#E3E0FB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.502,
    cy: 38.5014,
    rx: 4.5,
    ry: 4.49859,
    transform: "rotate(-180 45.502 38.5014)",
    fill: "#E3E0FB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 192.502 84.5014)",
    fill: "#E3E0FB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 201.502 30.4975)",
    fill: "#E3E0FB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.502,
    cy: 83.5014,
    rx: 4.5,
    ry: 4.49859,
    transform: "rotate(-180 56.502 83.5014)",
    fill: "#E3E0FB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.5,
    cy: 36.5014,
    rx: 4.5,
    ry: 4.49859,
    transform: "rotate(-180 4.5 36.5014)",
    fill: "#E3E0FB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(1 0 0 -1 238.5 47.5014)",
    fill: "#E3E0FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.502,
    cy: 81.5,
    r: 4.5,
    transform: "rotate(-180 14.502 81.5)",
    fill: "#E3E0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.467 13.7852L121.995 0L84.8915 13.6036C80.1538 15.8984 76 17.2686 76 21.7922V44.3052C76 59.9395 79.9995 75.4306 88.2244 89.1058C95.1437 100.613 105.864 112.466 122.364 120C137.53 114.954 148.851 101.493 155.776 89.9862C164 76.3111 168 60.8145 168 45.1857V24.9399C168 18.4903 164.667 15.3426 159.472 13.7907L159.467 13.7852Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.633 32.6742C147.764 34.0995 148.611 36.8919 147.531 38.928C147.297 39.3643 139.705 47.0725 130.654 56.0605C112.551 74.0365 113.281 73.4547 110.507 72.7275C109.427 72.4367 108.318 71.4768 103.062 66.2411C99.6458 62.8669 96.6384 59.6673 96.3757 59.1147C95.7333 57.7475 95.9377 55.3624 96.8136 54.1407C98.0691 52.4246 100.58 51.6392 102.595 52.3664C103.033 52.5409 105.281 54.5479 107.588 56.8168L111.734 60.9472L125.836 46.927C133.574 39.2189 140.319 32.7033 140.786 32.4706C142.129 31.7725 144.436 31.8598 145.633 32.6742Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.633 32.6742C147.764 34.0995 148.611 36.8919 147.531 38.928C147.297 39.3643 139.705 47.0725 130.654 56.0605C112.551 74.0365 113.281 73.4547 110.507 72.7275C109.427 72.4367 108.318 71.4768 103.062 66.2411C99.6458 62.8669 96.6384 59.6673 96.3757 59.1147C95.7333 57.7475 95.9377 55.3624 96.8136 54.1407C98.0691 52.4246 100.58 51.6392 102.595 52.3664C103.033 52.5409 105.281 54.5479 107.588 56.8168L111.734 60.9472L125.836 46.927C133.574 39.2189 140.319 32.7033 140.786 32.4706C142.129 31.7725 144.436 31.8598 145.633 32.6742Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.583ac1fae0ad12e5f9337e3a850d4936.svg";
export { ForwardRef as ReactComponent };